/**
 * Données de la galerie – CV Allen Le Yaouanc
 * Ce fichier est volontairement séparé pour rester lisible et maintenable.
 */

import illu01 from '@/assets/gallery/illu-01.jpg';
import illu02 from '@/assets/gallery/illu-02.jpg';
import foulard01 from '@/assets/gallery/foulard-01.jpg';
import foulard02 from '@/assets/gallery/foulard-02.jpg';
import foulard03 from '@/assets/gallery/foulard-03.jpg';
import foulard04 from '@/assets/gallery/foulard-04.jpg';
import foulard05 from '@/assets/gallery/foulard-05.jpg';
import illu04 from '@/assets/gallery/illu-04.jpg';

export interface GalleryItem {
  type: 'image' | 'video' | 'carousel';
  src: string;
  /** Sources multiples pour le type carousel */
  slides?: string[];
  alt?: string;
  caption?: string;
  /** Lien optionnel dans la légende */
  captionLink?: { label: string; url: string };
}

const galleryItems: GalleryItem[] = [
  {
    type: 'video',
    src: '/videos/fsmsk_hiver2025-2026.mp4',
    caption:
      "Projet expérimental mêlant création visuelle, audio et montage, pensé pour des usages brand content / campagne sportswear. Usage d'IA spécialisées (Kive + Suno). Édition dans Adobe Première et Audition.",
  },
  {
    type: 'image',
    src: illu01,
    alt: 'Illustration géopolitique – caricature',
    caption:
      "Illustration éditoriale pour la presse en ligne. Usage d'IA spécialisée + Photoshop.",
  },
  {
    type: 'image',
    src: illu04,
    alt: 'Direction artistique – Album Verbovskaya plays Chopin',
    caption:
      "Conception et direction artistique de l'habillage graphique d'un album de musique classique. CD pensé comme un objet d'art à part entière, s'éloignant des codes traditionnels du classique. Travail sur un design contemporain, un packaging soigné et cohérent. Approche transversale mêlant direction artistique, graphisme éditorial et sens de l'objet, avec une attention particulière portée à la matérialité, à la lisibilité et à la valeur esthétique du support physique. Photoshop + Illustrator.",
  },
  {
    type: 'image',
    src: illu02,
    alt: 'Couverture Conflits – Ukraine',
    caption:
      "Illustration éditoriale pour la presse papier. Usage d'IA spécialisée + Photoshop.",
  },
  {
    type: 'carousel',
    src: foulard01,
    slides: [foulard01, foulard02, foulard05, foulard03, foulard04],
    alt: 'Foulards en soie haut de gamme',
    caption:
      "Conception de foulards en soie haut de gamme : transposition d'œuvres d'art en pièces textiles, développées en collaboration avec un artisan soyeux lyonnais d'excellence.",
    captionLink: {
      label: 'behance.net',
      url: 'https://www.behance.net/gallery/155262703/From-screen-to-hand',
    },
  },
];

export default galleryItems;
